import { useState } from 'react';
import { LuFileText } from 'react-icons/lu';
import { useTheme } from 'styled-components';

export interface IMedsusCard {
  id: string;
  tipo: string; // ex: PCDT
  titulo: string;
  abrangencia: string;
  responsavelAquisicao: string;
  componente: string;
  status?: string;
  resumo?: string;
  tags: string[];
}

interface CardMedsusItemProps {
  data: IMedsusCard;
  onClick?: (id: string) => void;
}

export function CardMedsusItem({ data, onClick }: CardMedsusItemProps) {
  const theme = useTheme();
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onClick?.(data.id)}
      style={{
        padding: '24px',
        backgroundColor: '#fff',
        width: '100%',
        height: 'auto',
        borderRadius: '16px',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        transform: isHover ? 'scale(1.01)' : 'scale(1)',
        boxShadow: isHover
          ? '0 8px 24px rgba(0,0,0,0.08)'
          : '0 2px 8px rgba(0,0,0,0.04)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 1fr',
            gap: '20px',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#E7F0FB',
              width: '80px',
              height: '80px',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LuFileText
              size={36}
              color={theme.colors.azulgov}
              strokeWidth={1.5}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
              {data.titulo}
            </div>

            <div style={{ marginTop: '5px' }}>
              <div
                style={{ display: 'flex', gap: '12px', alignItems: 'center' }}
              >
                <span
                  style={{
                    backgroundColor: theme.colors.azulgov,
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                  }}
                >
                  {data.tipo}
                </span>
                <span
                  style={{
                    backgroundColor: theme.colors.amarelogov,
                    color: 'black',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                  }}
                >
                  {data.componente}
                </span>

                <span
                  style={{
                    backgroundColor: theme.colors.verdegov,
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                  }}
                >
                  {data.abrangencia.toLocaleUpperCase()}
                </span>
                {data.status && (
                  <span
                    style={{
                      backgroundColor: theme.colors.vermelho,
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '0.85rem',
                      fontWeight: 600,
                    }}
                  >
                    RENAME
                  </span>
                )}
              </div>
              <div style={{ marginTop: '15px', fontSize: '1.1rem' }}>
                {data.resumo ||
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
